import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useContext, useRef } from 'react';
import classnames from 'classnames';
import ddt from '@wix/da-ddt';
import { useDeviationViewContext } from '../../Context';
import Full from '../../DeviationViews/Full';
import DuperbrowsePaddles from '../../Duperbrowse/DuperbrowsePaddles';
import StageBackground from '../../DeviationBackground/StageBackground';
import { SubscriptionPurchaseFTUEContext } from '../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUEContext';
import SubscriptionPurchaseFTUE from '../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUE';
import { useMeasuredStage } from '../hooks/useMeasuredStage';
import StageContainer from '../_partials/StageContainer';
import ZoomModalFromImageSource from '../_partials/ZoomModalFromImageSource';
import StashPaddles from '../_partials/StashPaddles';
import styles from './DesktopArtStage.scss';
// precondition: the following Desktop DeviationTypes don't end up here:
//   POLL, STATUS, COMMISSION, TIER, JOURNAL, LITERATURE (they have their own ArtStages)
// that currently leaves:
//   UNKNOWN, IMAGE, FILM, PDF
const logger = ddt.createLogger('multifile');
export const DesktopSingleArtStage = ({ deviation, zoomedImageSource, isZoomed, onEnterZoomMode, onExitZoomMode, className })=>{
    logger.log('DesktopSingleArtStage:', deviation.title, deviation.type);
    const { isFullscreen } = useDeviationViewContext();
    const ref = useRef(null);
    const { contentSize, containerSize } = useMeasuredStage(ref, !isFullscreen);
    const isSubscriptionPurchaseFTUEBeingShown = !!useContext(SubscriptionPurchaseFTUEContext);
    var _zoomedImageSource_isPublished;
    return /*#__PURE__*/ React.createElement(StageContainer, {
        className: classnames(styles['root'], className, isFullscreen && styles['fullscreen']),
        withoutInnerWrapper: true
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles['content'],
        ref: ref
    }, /*#__PURE__*/ React.createElement(StageBackground, {
        deviation: deviation,
        width: containerSize === null || containerSize === void 0 ? void 0 : containerSize.width,
        height: containerSize === null || containerSize === void 0 ? void 0 : containerSize.height
    }), /*#__PURE__*/ React.createElement(Full, {
        deviation: deviation,
        width: contentSize === null || contentSize === void 0 ? void 0 : contentSize.width,
        height: contentSize === null || contentSize === void 0 ? void 0 : contentSize.height,
        withoutZoomModal: true,
        isZoomed: isZoomed,
        onEnterZoomMode: onEnterZoomMode,
        onExitZoomMode: onExitZoomMode
    }), deviation.isPublished && /*#__PURE__*/ React.createElement(DuperbrowsePaddles, {
        className: styles['duperbrowse']
    }), !deviation.isPublished && /*#__PURE__*/ React.createElement(StashPaddles, null)), zoomedImageSource && /*#__PURE__*/ React.createElement(ZoomModalFromImageSource, _object_spread_props(_object_spread({
        source: zoomedImageSource,
        allowFullviewSrcsetForPngs: (_zoomedImageSource_isPublished = zoomedImageSource === null || zoomedImageSource === void 0 ? void 0 : zoomedImageSource.isPublished) !== null && _zoomedImageSource_isPublished !== void 0 ? _zoomedImageSource_isPublished : false
    }, contentSize), {
        isZoomed: isZoomed,
        onExitZoomMode: onExitZoomMode
    })), isSubscriptionPurchaseFTUEBeingShown && /*#__PURE__*/ React.createElement(SubscriptionPurchaseFTUE, {
        className: styles['subscription-purchase-ftue']
    }));
};
DesktopSingleArtStage.displayName = 'DesktopSingleArtStage';
export default DesktopSingleArtStage;

//# sourceMappingURL=DesktopSingleArtStage.js.map